// ===========================================================================
// Playground (Módulo DEV-ONLY) — entry point.
//
// Solo se monta en desarrollo (NODE_ENV === "development"). El gating se hace
// con PLAYGROUND_ENABLED en AppRouter (rutas) y navigationConfig (sidebar).
// Ver common/constants.js para el detalle del gating.
// ===========================================================================
import PlaygroundPage from "./pages/PlaygroundPage";

export { PlaygroundPage };
export { PLAYGROUND_ENABLED, PLAYGROUND_BASE_PATH } from "./common/constants";
export default PlaygroundPage;
